module.exports = __webpack_public_path__ + "static/media/18C_CNG.b0d6671d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/tco/assets/18C_CNG.jpg
// module id = 1482
// module chunks = 0